import PhotosTypes from './PhotosTypes';

export default PhotosTypes;
